/**
 * Constants for neighbourhood feature
 * Fallback data and default values
 */

import { PersonaType } from './personaTypes';

export const NEIGHBOURHOOD_FALLBACK = {
  DESCRIPTION:
    'A vibrant, family-friendly community known for its tree-lined streets and strong sense of community. The neighbourhood offers an ideal blend of urban convenience and suburban tranquility, with excellent schools and abundant green spaces.',
  LOCATION_NAME: 'Greenwood Heights',
  TAGS: [
    { id: '1', label: 'Family Friendly', type: 'family' },
    { id: '2', label: 'Top Transit', type: 'transit' },
    { id: '3', label: 'Great Schools', type: 'schools' },
  ],
} as const;

export const DEFAULT_PERSONA = 'Family';

export const PLACEHOLDER_VALUES = new Set(['', 'n/a', 'unknown']);

export const PERSONA_STATS_TRANSLATION_KEYS = {
  [PersonaType.Family]: ['zoneType', 'parksNearby', 'nearestSchool'],
  [PersonaType.Professional]: ['commuteToCenter', 'taxMultiplier', 'connectivitySpeed'],
  [PersonaType.Students]: ['toUniversity', 'mobility', 'nightLinks'],
} as const satisfies Record<PersonaType, readonly string[]>;
